import _classCallCheck from "/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/esm/inherits";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { Info } from './info.js';
import * as types from './types.js';
/** @type {Array<keyof types>} */
// @ts-expect-error: hush.

var checks = Object.keys(types);
export var DefinedInfo = /*#__PURE__*/function (_Info) {
  _inherits(DefinedInfo, _Info);

  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  function DefinedInfo(property, attribute, mask, space) {
    var _this;

    _classCallCheck(this, DefinedInfo);

    var index = -1;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DefinedInfo).call(this, property, attribute));
    mark(_assertThisInitialized(_this), 'space', space);

    if (typeof mask === 'number') {
      while (++index < checks.length) {
        var check = checks[index];
        mark(_assertThisInitialized(_this), checks[index], (mask & types[check]) === types[check]);
      }
    }

    return _this;
  }

  return DefinedInfo;
}(Info);
DefinedInfo.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */

function mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
  }
}